import { render, staticRenderFns } from "./ReadContractView.vue?vue&type=template&id=fa5dd840&"
import script from "./ReadContractView.vue?vue&type=script&lang=js&"
export * from "./ReadContractView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports